import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../components/Layout';
import Sitemap from '../views/Sitemap';

const SitemapPage = props => {
  const {
    pageContext: { locale },
    location: { pathname },
  } = props;

  return (
    <Layout locale={locale} localeDir={pathname}>
      <Sitemap locale={locale} />
    </Layout>
  );
};

SitemapPage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string,
    locales: PropTypes.shape({
      [PropTypes.string]: PropTypes.string,
    }),
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default SitemapPage;
